<template>
  <div class="lugproApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="header">
      <h3>{{setLuggage.title}}</h3>
      <div class="li">
        <h2>营业时间：{{setLuggage.business}}<font>销量：{{setLuggage.total}}</font></h2>
      </div>
    </div>
    <div class="goods" :style="'height:'+(curHeight-76)+'px'">
      <ul>
        <li class="curt">全部类型</li>
        <li style="height:50px"></li>
      </ul>
      <dl class="proList">
        <dd @click="$router.push('ldetail?id='+setLuggage.id+'-'+vo.id)" v-for="(vo,i) in setLuggage.pro">
          <div class="fmt">
            <el-image style="width:100%;height:70px; border-radius:5px;" :src="baseUrl+vo.image" fit="cover"></el-image>
          </div>
          <div class="right">
            <h2>{{vo.title}}</h2>
            <div class="sales">销量：{{vo.total}}</div>
            <div class="price"><span>￥{{vo.rate}}</span></div>
          </div>
          <i class="el-icon-shopping-cart-1"></i>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setLuggage:[],
        code:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var id = this.$route.query.id
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/lugpro?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.getLuggage();
      }
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLuggage:function(){
        var that = this;
        var id = this.$route.query.id
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/getLuggage',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setLuggage = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getLuggage();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  
  .lugproApp{
    max-width:750px;
    background:#F1F2F5;
    margin:0 auto;
  }
  .lugproApp .header{
    height:75px;
    background:#fff;
    width:100%;
    border-bottom:1px solid #F1F2F5
  }

  .lugproApp .header .li{
    width:100%;
    background:#fff;
  }
  .lugproApp .header h3{
    font-size:16px;
    padding:8px 0 0 3%
  }
  .lugproApp .header .li h2{
    width:94%;
    margin:0 auto;
    font-size:14px;
    padding-top:10px;
    font-weight:500;
    color:#555
  }
  .lugproApp .header .li h2 font{
    float:right;
    color:#f00;
    font-size:12px;
    margin-top:4px
  }
  .lugproApp .goods{
    overflow-y: scroll;
    width:100%;
    position: relative;
  }

  .lugproApp .goods ul{
    width:25%;
    background:#fff;
    position: absolute;
    left:0;
    top:0;
    height:100%;
    overflow-y: scroll;
  }
  .lugproApp .goods ul li{
    font-size:14px;
    text-align:center;
    padding:15px 10px;
    color:#555;
    border-bottom:1px solid #fff
  }
  .lugproApp .goods ul li.curt{
    color:#FF1E00
  }
  .lugproApp .goods ul li:last-child{
    border-bottom:none
  }
  .lugproApp .goods .proList{
    width:73%;
    position: absolute;
    left:27%;
    top:0%;
    height:100%;
    overflow-y: scroll;
    background:#fff;
  }
  .lugproApp .goods .proList dd{
    width:93%;
    position: relative;
    margin:12px auto 0 auto;
    border-bottom:solid 1px #F1F2F5;
    padding-bottom:12px
  }
  .lugproApp .goods .proList dd:last-child{
    border-bottom:none;
  }
  .lugproApp .goods .proList dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .lugproApp .goods .proList .fmt{
    float:left;
    width:32%;
    font-size:0
  }
  .lugproApp .goods .proList .right{
    float:left;
    width:66%;
    margin-left:2%;
    position: relative;
  }
  .lugproApp .goods .proList .right h2{
    font-size:15px;
    color:#000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .lugproApp .goods .proList .right .sales{
    font-size:13px;
    color:#999;
    padding:7px 0
  }
  .lugproApp .goods .proList .right .price{
    font-weight:bold;
    color:#F20000;
    font-size:13px
  }
  .lugproApp .goods .proList .right .price font{
    color:#999;
    font-weight:normal;
    font-size:12px;
    text-decoration: line-through;
    padding-left:8px
  }
  .lugproApp .goods .proList dd i{
    position: absolute;
    width:25px;
    height:25px;
    background:rgba(255, 0, 0, .6);
    color:#fff;
    border-radius: 50%;
    font-size:14px;
    text-align:center;
    line-height:27px;
    bottom:15px;
    right:2%;
  }
</style>